import { useState, useEffect } from 'react'
import { getHolidayTypeAPI } from '../services/holiday'
import { Button, ButtonGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

function UseTypeHoliday() {
   const [type, setType] = useState([])
  useEffect(() => {
   
   
    const getHolidayType = async () => {
      const res = await getHolidayTypeAPI();
      if (!res) return;
      const newData = res.result.map((d, i) => {
        return {
          value: d.id,
          label: d.holiday_type,
        }
      })

      setType(newData)
    }
    getHolidayType()
  }, [])
  const dispatch = useDispatch();
  return  type
}

export default UseTypeHoliday
